export const TEMPLE_ADDRESS = {
  name: 'Yugal Kunj \u2013 Radha Krishna Temple and Community Center',
  street: '2769 Duluth Hwy, Duluth, GA 30096',
};

export const DONATION_TYPES = {
  ONLINE: 'online',
  PHYSICAL: 'physical',
};

export const PAYMENT_METHODS = {
  CARD: 'creditcard',
  ACH: 'ach',
};

export const FREQUENCIES = {
  ONETIME: 'onetime',
  RECURRING: 'recurring',
};

export const SUBSCRIPTION_END_TYPES = {
  NO_END: 'NoEndDate',
  ON_DATE: 'EndsOnDate',
  AFTER_TERMS: 'EndsAfterTerms',
};

export const DROP_OFF_TIME_SLOTS = [
  '9:00 AM - 11:00 AM',
  '11:00 AM - 1:00 PM',
  '1:00 PM - 3:00 PM',
  '3:00 PM - 5:00 PM',
  '5:00 PM - 7:00 PM',
];

export const STEPS = [
  { id: 1, label: 'Select Items' },
  { id: 2, label: 'Your Information' },
  { id: 3, label: 'Payment' },
];

export const DEFAULT_DONOR = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'United States',
  specialInstructions: '',
};

export const DEFAULT_CARD = {
  cardNumber: '',
  expiryDate: '',
  cvv: '',
  billingZipCode: '',
};

export const DEFAULT_ACH = {
  accountType: 'Checking',
  routingNumber: '',
  accountNumber: '',
  bankName: '',
};

export const DEFAULT_RECURRING = {
  startDate: '',
  endDate: '',
  endType: SUBSCRIPTION_END_TYPES.NO_END,
  numberOfTerms: '12',
};

export const formatCurrency = (value) =>
  `$${Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatCardNumber = (value) =>
  (value || '')
    .replace(/\D/g, '')
    .slice(0, 16)
    .replace(/(\d{4})(?=\d)/g, '$1 ');

export const formatExpiry = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
};

// US ZIP only: 5 digits, auto-hyphenating into ZIP+4 when more are entered
export const formatZip = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const formatCvv = (value) => (value || '').replace(/\D/g, '').slice(0, 4);

export const formatPhone = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const calculateTotal = (items) =>
  items.reduce((sum, item) => sum + Number(item.quantity || 0) * Number(item.estimatedPrice || 0), 0);

export const getSelectedItems = (items) => items.filter((item) => Number(item.quantity) > 0);
